var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.32698 1.63803C0 2.27976 0 3.11984 0 4.8V11.2C0 12.8802 0 13.7202 0.32698 14.362C0.614601 14.9265 1.07354 15.3854 1.63803 15.673C2.27976 16 3.11984 16 4.8 16H15.2C16.8802 16 17.7202 16 18.362 15.673C18.9265 15.3854 19.3854 14.9265 19.673 14.362C20 13.7202 20 12.8802 20 11.2V4.8C20 3.11984 20 2.27976 19.673 1.63803C19.3854 1.07354 18.9265 0.614601 18.362 0.32698C17.7202 0 16.8802 0 15.2 0H4.8C3.11984 0 2.27976 0 1.63803 0.32698C1.07354 0.614601 0.614601 1.07354 0.32698 1.63803ZM5.56569 4.17538C5.11026 3.86296 4.4878 3.97889 4.17538 4.43431C3.86296 4.88974 3.97889 5.5122 4.43431 5.82462L8.30293 8.47849C9.32556 9.18002 10.6744 9.18002 11.6971 8.47849L15.5657 5.82462C16.0211 5.5122 16.137 4.88974 15.8246 4.43431C15.5122 3.97889 14.8897 3.86296 14.4343 4.17538L10.5657 6.82926C10.2248 7.0631 9.77519 7.0631 9.43431 6.82926L5.56569 4.17538Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailShape);
export default __webpack_public_path__ + "static/media/emailShape.8355c0b048306890e544b1762ada4e01.svg";
export { ForwardRef as ReactComponent };